import { render, staticRenderFns } from "./QuizView.vue?vue&type=template&id=5dbb54dd&scoped=true&"
import script from "./QuizView.vue?vue&type=script&lang=js&"
export * from "./QuizView.vue?vue&type=script&lang=js&"
import style0 from "./QuizView.vue?vue&type=style&index=0&id=5dbb54dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbb54dd",
  null
  
)

/* custom blocks */
import block0 from "./QuizView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports